import React, { Fragment } from 'react'
import Formwizard from './formwizard/Formwizard'

const OfferVKIWizard = () => {
  return (
    <Fragment>
      <Formwizard />
    </Fragment>
  )
}

export default OfferVKIWizard
